export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON deer house CY.4c8b5861.png";